var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "msa-config" }, [
    _c(
      "div",
      { staticClass: "config-field" },
      [
        _c(
          "v-tooltip",
          {
            attrs: { right: "", "nudge-left": "15px" },
            scopedSlots: _vm._u([
              {
                key: "activator",
                fn: function ({ on, attrs }) {
                  return [
                    _c(
                      "span",
                      _vm._g(
                        _vm._b(
                          { staticClass: "config-label" },
                          "span",
                          attrs,
                          false
                        ),
                        on
                      ),
                      [_vm._v("Alphabet")]
                    ),
                  ]
                },
              },
            ]),
          },
          [
            _vm._v(" "),
            _c("span", [
              _vm._v("Switch between amino acid and 3Di alignment views"),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "v-btn-toggle",
          {
            staticClass: "alphabet-toggle",
            attrs: {
              dense: "",
              mandatory: "",
              disabled: _vm.busy || _vm.representations.length === 0,
              value: _vm.activeRepresentationId || "",
            },
            on: { change: _vm.handleRepresentationChange },
          },
          _vm._l(_vm.representations, function (representation) {
            return _c(
              "v-btn",
              {
                key: representation.id,
                attrs: { value: representation.id, disabled: _vm.busy },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.representationShortLabel(representation)) +
                    "\n            "
                ),
              ]
            )
          }),
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "config-field" },
      [
        _c(
          "v-tooltip",
          {
            attrs: { right: "", "nudge-left": "15px" },
            scopedSlots: _vm._u([
              {
                key: "activator",
                fn: function ({ on, attrs }) {
                  return [
                    _c(
                      "span",
                      _vm._g(
                        _vm._b(
                          { staticClass: "config-label" },
                          "span",
                          attrs,
                          false
                        ),
                        on
                      ),
                      [_vm._v("Gaps")]
                    ),
                  ]
                },
              },
            ]),
          },
          [
            _vm._v(" "),
            _c("span", [
              _vm._v("Hide columns with a gap fraction above this threshold"),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("input", {
          staticClass: "control-input",
          attrs: {
            id: "msa-gap-threshold-input",
            type: "number",
            min: "0",
            max: "1",
            step: "0.01",
            disabled: _vm.busy,
          },
          domProps: { value: _vm.gapThreshold },
          on: {
            input: _vm.handleGapThresholdChange,
            change: _vm.handleGapThresholdChange,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "config-field" },
      [
        _c(
          "v-tooltip",
          {
            attrs: { right: "", "nudge-left": "15px" },
            scopedSlots: _vm._u([
              {
                key: "activator",
                fn: function ({ on, attrs }) {
                  return [
                    _c(
                      "span",
                      _vm._g(
                        _vm._b(
                          { staticClass: "config-label" },
                          "span",
                          attrs,
                          false
                        ),
                        on
                      ),
                      [_vm._v("Colour")]
                    ),
                  ]
                },
              },
            ]),
          },
          [
            _vm._v(" "),
            _c("span", [
              _vm._v("Choose the colour scheme used for alignment cells"),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "v-menu",
          {
            attrs: {
              "offset-y": "",
              disabled: _vm.busy || _vm.schemes.length === 0,
            },
            scopedSlots: _vm._u([
              {
                key: "activator",
                fn: function ({ on, attrs }) {
                  return [
                    _c(
                      "v-btn",
                      _vm._g(
                        _vm._b(
                          {
                            staticClass: "scheme-menu-button",
                            attrs: {
                              small: "",
                              depressed: "",
                              disabled: _vm.busy || _vm.schemes.length === 0,
                            },
                          },
                          "v-btn",
                          attrs,
                          false
                        ),
                        on
                      ),
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.activeSchemeLabel || "None") +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          },
          [
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "scheme-menu-panel" },
              [
                _vm._l(_vm.schemeGroups, function (group) {
                  return [
                    _c(
                      "div",
                      {
                        key: `${group.label}:header`,
                        staticClass: "scheme-menu-heading",
                      },
                      [_vm._v(_vm._s(group.label))]
                    ),
                    _vm._v(" "),
                    _vm._l(group.options, function (option) {
                      return _c(
                        "button",
                        {
                          key: option.id,
                          staticClass: "scheme-menu-option",
                          class: {
                            "is-active":
                              option.value === _vm.activeSchemeOptionValue,
                          },
                          attrs: { type: "button", title: option.label },
                          on: {
                            click: function ($event) {
                              return _vm.handleSchemeChange(option.value)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(option.shortLabel) +
                              "\n                    "
                          ),
                        ]
                      )
                    }),
                  ]
                }),
              ],
              2
            ),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "config-field" },
      [
        _c(
          "v-tooltip",
          {
            attrs: { right: "", "nudge-left": "15px" },
            scopedSlots: _vm._u([
              {
                key: "activator",
                fn: function ({ on, attrs }) {
                  return [
                    _c(
                      "span",
                      _vm._g(
                        _vm._b(
                          { staticClass: "config-label" },
                          "span",
                          attrs,
                          false
                        ),
                        on
                      ),
                      [_vm._v("Tracks")]
                    ),
                  ]
                },
              },
            ]),
          },
          [
            _vm._v(" "),
            _c("span", [
              _vm._v("Show or hide annotation tracks below the alignment"),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "v-menu",
          {
            attrs: {
              "offset-y": "",
              "close-on-content-click": false,
              disabled: _vm.busy || _vm.displayTracks.length === 0,
            },
            scopedSlots: _vm._u([
              {
                key: "activator",
                fn: function ({ on, attrs }) {
                  return [
                    _c(
                      "v-btn",
                      _vm._g(
                        _vm._b(
                          {
                            staticClass: "track-menu-button",
                            attrs: {
                              small: "",
                              depressed: "",
                              disabled:
                                _vm.busy || _vm.displayTracks.length === 0,
                            },
                          },
                          "v-btn",
                          attrs,
                          false
                        ),
                        on
                      ),
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.enabledTrackCount > 0
                                ? `${_vm.enabledTrackCount} shown`
                                : "None"
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          },
          [
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "track-menu-panel",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c("div", { staticClass: "track-menu-header" }, [
                  _c("div", { staticClass: "track-menu-heading" }, [
                    _vm._v("Tracks"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "track-menu-mode" }, [
                    _c("span", [_vm._v(_vm._s(_vm.trackDisplayModeLabel))]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "track-menu-reset",
                        attrs: {
                          type: "button",
                          "aria-hidden":
                            _vm.trackDisplayMode === "none" ? "false" : "true",
                          title: "Reset to active-only",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("reset-track-defaults")
                          },
                        },
                      },
                      [_vm._v("↻")]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "track-menu-table" },
                  _vm._l(_vm.displayTracks, function (track) {
                    return _c(
                      "div",
                      { key: track.id, staticClass: "track-menu-row" },
                      [
                        _c("div", { staticClass: "track-menu-title" }, [
                          _vm._v(_vm._s(track.label || track.id)),
                        ]),
                        _vm._v(" "),
                        _vm._l(track.variants, function (variant) {
                          return _c(
                            "label",
                            {
                              key: `${variant.trackId}:${
                                variant.representation || ""
                              }`,
                              staticClass: "track-menu-option",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                },
                              },
                            },
                            [
                              _c("input", {
                                attrs: { type: "checkbox" },
                                domProps: { checked: variant.enabled === true },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                  change: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.handleTrackChange(
                                      variant,
                                      $event
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.trackVariantLabel(track, variant)
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.trackVariantLabel(track, variant)
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.trackMenuFillers(track), function (index) {
                          return _c("div", {
                            key: `${track.id}:filler:${index}`,
                            staticClass: "track-menu-empty",
                            attrs: { "aria-hidden": "true" },
                          })
                        }),
                      ],
                      2
                    )
                  }),
                  0
                ),
              ]
            ),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "config-field" },
      [
        _c(
          "v-tooltip",
          {
            attrs: { right: "", "nudge-left": "15px" },
            scopedSlots: _vm._u([
              {
                key: "activator",
                fn: function ({ on, attrs }) {
                  return [
                    _c(
                      "span",
                      _vm._g(
                        _vm._b(
                          { staticClass: "config-label" },
                          "span",
                          attrs,
                          false
                        ),
                        on
                      ),
                      [_vm._v("Selection")]
                    ),
                  ]
                },
              },
            ]),
          },
          [
            _vm._v(
              "Clear the current column selection or export it as FASTA\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "selection-actions" },
          [
            _c(
              "v-btn",
              {
                staticClass: "selection-action-button",
                attrs: {
                  small: "",
                  depressed: "",
                  disabled: _vm.busy || _vm.selectionCount === 0,
                  title: "Clear selection",
                  "aria-label": "Clear selection",
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("clear-selection")
                  },
                },
              },
              [
                _c("v-icon", { attrs: { small: "" } }, [
                  _vm._v(_vm._s(_vm.$MDI.CloseCircleOutline)),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                staticClass: "selection-action-button",
                attrs: {
                  small: "",
                  depressed: "",
                  disabled: _vm.busy || _vm.selectionCount === 0,
                  title: "Export selection as FASTA",
                  "aria-label": "Export selection as FASTA",
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("export-selection-fasta")
                  },
                },
              },
              [
                _c("v-icon", { attrs: { small: "" } }, [
                  _vm._v(_vm._s(_vm.$MDI.FileDownloadOutline)),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }